import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router";
import { Link as RouterLink } from "react-router";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

import Button from "components/Button";
import SocialHeader from "./SocialHeader";

import { ReactComponent as IbanLogo } from "assets/images/iban_oplata-logo.svg";

import { routes } from "routes/routes";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

const AppBarMui = styled(AppBar)(({ theme }) => ({
  position: "sticky",
  minHeight: 56,
  padding: 0,
  background: theme.palette.common.white,
  display: "flex",
  boxShadow: "none",

  "&.MuiPaper-root": {
    padding: "0 !important",
  },
}));

interface HeaderProps {
  website?: boolean;
}

type AllProps = HeaderProps;

const IbanHeader: FC<AllProps> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash === "#integration") {
      scrollToIntegration();
    }
  }, []);

  const goToCabinet = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_profile_btn_click,
      null,
      true,
    );
    navigate(routes.auth);
  };

  const scrollToIntegration = () => {
    const el = document.getElementById("integration");
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const onApiIntegrationClick = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_api_integration,
      null,
      true,
    );
    scrollToIntegration();
  };

  const onLogoClick = () => {
    analytics().sendEvent(AnalyticsEvents.iban_oplata_logo);

    if (
      window.location.pathname === routes.root ||
      window.location.pathname === routes.ibanOplata
    ) {
      const el = document.getElementById("create-iban");
      if (el) {
        const headerHeight = -88;
        const y =
          el.getBoundingClientRect().top + window.scrollY + headerHeight;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
      return;
    }

    navigate(routes.root);
  };

  const renderButtons = () => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", ml: "auto" }}>
        <Link
          component={RouterLink}
          variant="body1"
          to="/#integration"
          sx={{ mr: { xs: 3, sm: 4 }, fontWeight: "600" }}
          underline="none"
          color="textPrimary"
          onClick={onApiIntegrationClick}
        >
          API-інтеграція
        </Link>
        <Button
          sx={styles.button}
          variant="contained"
          color="secondary"
          onClick={goToCabinet}
          withBorder
        >
          Увійти
        </Button>
      </Box>
    );
  };

  return (
    <AppBarMui>
      <SocialHeader />
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          p: { xs: "12px 16px", sm: "24px" },
        }}
      >
        <IconButton aria-label="iban-logo" onClick={onLogoClick} sx={{ p: 0 }}>
          <IbanLogo style={{ height: "40px" }} />
        </IconButton>
        {renderButtons()}
      </Container>
    </AppBarMui>
  );
};

const styles = {
  button: {
    p: "12px 20px !important",
  },
  profileIcon: {
    p: 1.5,
    ml: 2,

    height: "48px",
    width: "48px",

    ":hover": {
      border: "none",
    },
  },
};

export default IbanHeader;
